
export { default as ArrowLeftIcon } from "./ArrowLeft.js"
export { default as ArrowRightIcon } from "./ArrowRight.js"